import './TaskFooter.scss';

export default function TaskFooter({ children }) {
  return <div className="etc-footer">{children}</div>;
}
